import { render, staticRenderFns } from "./FinishGoalConfirm.vue?vue&type=template&id=4bb37b74&"
import script from "./FinishGoalConfirm.vue?vue&type=script&lang=ts&"
export * from "./FinishGoalConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports